

































































import 'firebase/functions'
import firebaseApp from '@/firebaseApp'

import { Component, Vue } from 'vue-property-decorator'
import auth from '@/firebaseApp'
import Restaurants from '@/services/Restaurants'
import Roles from '@/services/Roles'
import Loader from '@/components/global/loader.vue'
@Component({
  components: { Loader },
})
export default class AllUsers extends Vue {
  public allUsersObject: any = null

  public async created() {
    const getAllUsers = firebaseApp.functions('europe-west1').httpsCallable('getAllUsers')
    this.allUsersObject = (await getAllUsers({})).data
  }

  public get adminUsers() {
    if (!this.allUsersObject) {
      return null
    }

    return this.allUsersObject.admins.map((uid: string) => this.getUsersFromUid(uid))
  }

  public async forgotPassword(email: string, continueUrlPart: string) {
    const continueUrl = `${window.config.baseUrl}/${continueUrlPart}`
    await auth.auth().sendPasswordResetEmail(email, {
      url: continueUrl,
    })

    alert(`${email} ${this.$i18n.t('admin.users.receivedMail')}`)
  }

  public async deleteAdmin(uid: string) {
    if (!confirm(this.$i18n.t('admin.users.confirmDeleteAdmin') + '')) {
      return
    }

    await Roles.deleteAdmin(uid)

    const index = this.allUsersObject.admins.indexOf(uid)
    this.allUsersObject.admins.splice(index, 1)
  }

  public async deleteOwner(uid: string, restaurantId: string) {
    if (!confirm(this.$i18n.t('admin.users.confirmDeleteOwner') + '')) {
      return
    }

    await Restaurants.deleteOwner(restaurantId, uid)

    const index = this.allUsersObject.owners[restaurantId].list.indexOf(uid)
    this.allUsersObject.owners[restaurantId].list.splice(index, 1)
  }

  public async deleteStaff(uid: string, restaurantId: string) {
    if (!confirm(this.$i18n.t('admin.users.confirmDeleteStaff') + '')) {
      return
    }

    await Restaurants.deleteStaff(restaurantId, uid)

    const index = this.allUsersObject.staff[restaurantId].list.indexOf(uid)
    this.allUsersObject.staff[restaurantId].list.splice(index, 1)
  }

  public getUsersFromUid(uid: string) {
    if (!this.allUsersObject || !uid) {
      return null
    }

    return this.allUsersObject.users.find((u: any) => u.uid === uid)
  }
}
